<template>
	<div class="main-content">
		<div class="center-body">
			<Nav style="margin-bottom: 15px;"></Nav>
			<div class="row" style="padding-left: 15px;margin-bottom: 15px;">
				<div class="item" style="align-items: center;">
					<span style="font-size: 18px;color: #333;cursor: pointer;">
						
					</span>
				</div>
				<div class="item" style="justify-content: flex-end;align-items: center;margin-top: 10px;">
					 <Button @click="goback">{{$t('lang.back')}}</Button>
				</div>
			</div>
			<div style="padding: 15px 120px;min-height: 800px;width: 1200px;margin: 0 auto;background: #fff;" >
				<div class="row" style="justify-content: center;font-size: 18px;padding: 15px;font-weight: 600;">
					{{detail.title}}
				</div>
				
				<div v-html="detail.content" class="news-box">{{detail.content}}</div>
				<div class="row" style="justify-content: flex-end;font-size: 14px;margin: 15px;color: #999;padding-right: 25px;">
					{{detail.createTime}}
				</div>
			</div>
		</div>	
	</div>
</template>

<script>
	import Nav from './nav.vue'
	export default {
		name: 'App',
		components: {
		    Nav
		},
		data() {
			return {
				detail:{}
			}
		},
		methods: {
			goback(){
				history.back()
			}
		},
		mounted() {
			if(this.$localstorage.getStore('new')){
				this.detail=this.$localstorage.getStore('new')
			}
		}
	}
</script>

<style scoped>
	.main-content {
		min-height: 100%;
		width: 100%;
		min-width: 1200px;
		margin: 0 auto;
		display: block;
		position: absolute;
		background: #f7f7f7;
		margin-top: 135px;
	}
	.center-body{
    	width: 1200px;
    	margin: 0 auto;
    }

	.news-box>>> p{
		line-height: 2rem;
	}

</style>